import { useState } from "react";
import { 
    ROUTE_USER_SETTINGS,
    ROUTE_EDIT_USER_SETTING
} from "../../../../routes/Routes";
import { useNavigate } from "react-router-dom";
import "./UserSettings.scss"
import ListViewConfig from "../../../../ListViewConfig/ListViewConfig";
import GetFetch from "../../../../hooks/GetFetch";
import { useEffect } from "react";

const UserSettings = () => {
    const [userSettings, setUserSettings] = useState();
    const [loading, setLoading] = useState(false);
    const { title } = ROUTE_USER_SETTINGS;

    const navigate = useNavigate();

    useEffect(() => {
        getUserSettings();
    }, [])

    const getUserSettings = async () => {
        setLoading(true);
        try {
            const { Errors, Message, Success } = await GetFetch("/v1/UserSettings/GetActiveUserSettingsByUser");
            if (Success) {
                setUserSettings(
                    Message.map(props => (
                        {
                            ...props,
                            Regions: [...new Set(props.Regions)].sort((a, b) => a - b).join(', ')
                        }
                    ))
                );
            }
            if (Errors.length > 0) console.error(Errors);
        }
        catch (error) {
            console.error(error);
        }
        setLoading(false);
    };

    const childProps = {
        columns: [
            {
                caption: 'Account Name',
                dataField: 'UserAccountName'
            },
            {
                caption: 'Email',
                dataField: 'EmailAddress'
            },
            {
                caption: 'Regions',
                dataField: 'Regions'
            },
            {
                caption: 'Contractor Company',
                dataField: 'ContractorCompany'
            },
            {
                caption: 'Job Title',
                dataField: 'JobTitle'
            },
            {
                caption: 'Role',
                dataField: 'Role.Name'
            },
            {
                caption: 'Contract Start Date',
                dataField: 'ContractStartDate'
            },
            {
                caption: 'Contract End Date',
                dataField: 'ContractEndDate'
            },
            {
                caption: 'Seperation Date',
                dataField: 'SeperationDate'
            },
            {
                caption: 'Updated Date',
                dataField: 'UpdatedDate'
            },
            {
                caption: 'Updated By',
                dataField: 'UpdatedBy'
            }
        ],
        dataSource: userSettings,
        isChild: false,
        keyExpr: "EDIPI",
        loadingIndicatorState: loading,
        loadingIndicatorLocationId: "List-View",
        loadingIndicatorMessage: `Loading ${ title }. Please wait...`,
        masterDetailComponent: ({ data }) => {
            const masterDetailProps = {
                columns: [
                    {
                        caption: 'User Email',
                        cellRender: ({ data }) => {
                            return (
                                <a
                                    style={{ fontWeight: 'bold', color: '#005288' }}
                                    onClick={() => {
                                        navigate(
                                            ROUTE_EDIT_USER_SETTING.withSlash, 
                                            { state: data }
                                        )
                                    }}>
                                    { `Edit: ${data.UserId}` }
                                </a>
                            );
                        },
                    },                
                    {
                        caption: 'Setting Name',
                        dataField: 'SettingName'
                    },
                    {
                        caption: 'Setting Value',
                        dataField: 'SettingValue'
                    },
                    {
                        caption: 'Created Date',
                        dataField: 'CreatedDate'
                    },
                    {
                        caption: 'Created By',
                        dataField: 'CreatedBy'
                    },
                    {
                        caption: 'Updated Date',
                        dataField: 'UpdatedDate'
                    },
                    {
                        caption: 'Updated By',
                        dataField: 'UpdatedBy'
                    },
                ],
                keyExpr: "UserId",
                dataSource: data.data.UserSetting,
                showSearchPanel: false,
                showToolBar: false,
            };

            return <ListViewConfig { ...masterDetailProps } />
        },
        masterDetailEnabled: true,
        permissions: false,
        showAddRecordButton: false,
        showSearchPanel: true,
        showToolBar: true,
        title: title
    };

    return <ListViewConfig { ...childProps } />;
};

export default UserSettings;